import rootReducer, { AggregatedState } from '@store/reducers';
import { AlertDispatchProps } from '@store/reducers/alerts';
import { TimeMode } from '@types';
import { IS_LOCALHOST } from '@utils';
import { MqttClient } from 'mqtt';
import {
  Action,
  applyMiddleware,
  compose,
  legacy_createStore as createStore,
} from 'redux';
import thunk from 'redux-thunk';

const composeEnhancers =
  (typeof window !== 'undefined' &&
    IS_LOCALHOST &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk)),
);
export { store };

export function dispatcher(
  type: string,
  payload?:
    | Partial<AggregatedState>
    | Partial<AlertDispatchProps>
    | { sn?: string }
    | { clientMQTT: MqttClient }
    | { timeMode: TimeMode },
): Action<string> & Record<string, unknown> {
  return {
    type,
    ...payload,
  };
}
